package com.partejar.app.feature.profile.data.remote

import com.partejar.app.core.network.ApiConfig
import com.partejar.app.feature.profile.data.UserProfile
import com.partejar.app.feature.profile.data.UserProfileDataSource
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.delete
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import kotlinx.coroutines.CancellationException

class UserProfileRemoteDataSource(
    private val client: HttpClient,
    private val apiConfig: ApiConfig,
    private val mapper: UserProfileRemoteMapper
) : UserProfileDataSource {
    override suspend fun get(): UserProfile = request {
        val response = client.get(apiConfig.endpoint("/me"))
        when (response.status) {
            HttpStatusCode.OK -> mapper.map(response.body<UserProfileDto>())
            else -> throw UserProfileUnavailableException()
        }
    }

    override suspend fun update(name: String, cpf: String?): UserProfile = request {
        val response = client.patch(apiConfig.endpoint("/me")) {
            contentType(ContentType.Application.Json)
            setBody(UpdateUserProfileDto(name, cpf))
        }
        when (response.status) {
            HttpStatusCode.OK -> mapper.map(response.body<UserProfileDto>())
            else -> throw UserProfileUnavailableException()
        }
    }
    override suspend fun registrations() = request { val response = client.get(apiConfig.endpoint("/me/registros-profissionais")); if (response.status == HttpStatusCode.OK) response.body<List<UserProfessionalRegistrationDto>>().map(mapper::registration) else throw UserProfileUnavailableException() }
    override suspend fun createRegistration(input: com.partejar.app.feature.profile.data.UserProfessionalRegistrationInput) = request { val response = client.post(apiConfig.endpoint("/me/registros-profissionais")) { contentType(ContentType.Application.Json); setBody(UserProfessionalRegistrationRequestDto(input.category, input.council, input.number, input.state)) }; if (response.status == HttpStatusCode.Created) mapper.registration(response.body()) else throw UserProfileUnavailableException() }
    override suspend fun updateRegistration(id: Long, input: com.partejar.app.feature.profile.data.UserProfessionalRegistrationInput) = request { val response = client.patch(apiConfig.endpoint("/me/registros-profissionais/$id")) { contentType(ContentType.Application.Json); setBody(UserProfessionalRegistrationRequestDto(input.category, input.council, input.number, input.state)) }; if (response.status == HttpStatusCode.OK) mapper.registration(response.body()) else throw UserProfileUnavailableException() }
    override suspend fun deactivateRegistration(id: Long) = request { val response = client.delete(apiConfig.endpoint("/me/registros-profissionais/$id")); if (response.status != HttpStatusCode.NoContent) throw UserProfileUnavailableException() }

    private suspend fun <T> request(block: suspend () -> T): T = try {
        block()
    } catch (error: CancellationException) {
        throw error
    } catch (error: UserProfileUnavailableException) {
        throw error
    } catch (error: Throwable) {
        throw UserProfileUnavailableException(error)
    }
}

class UserProfileUnavailableException(cause: Throwable? = null) : Exception(cause)
